const baseURL = 'https://restaurante.komerzy.com/';

export default baseURL;
